import React from 'react';
import './bibliography.css';
import ButtonComponent from '../../../shared/button/Button.component';
import {NavigateFunction, useNavigate} from 'react-router-dom';
import {ExternalLink} from 'lucide-react';

interface BibliographyProps {
    t: (key: string) => string;
}

const Bibliography: React.FC<BibliographyProps> = ({t}) => {

    const navigate: NavigateFunction = useNavigate();

    const goBackButtonText: string = t('go_back_button');

    const goBackButtonHandler: () => void = (): void => {
        navigate('/results');
    }

    return (
        <div className="bibliography__main-wrapper">

            <div className="bibliography_go-back__wrapper">
                <ButtonComponent id="goBackButton"
                                 value={goBackButtonText}
                                 className="go-back_next__button"
                                 onClick={goBackButtonHandler}/>
            </div>

            <div className="bibliography_content__wrapper">

                <ol>
                    <li>
                        <a href="https://www.gov.pl/web/psse-rzeszow/program-szczepien-ochronnych-na-rok-2025"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Komunikat Głównego Inspektora Sanitarnego z dnia 31 października 2024 r. w sprawie Programu
                            Szczepień
                            Ochronnych na rok 2025 <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        K. Tomasiewicz. Monografia. Szczepienia ochronne u dorosłych. MPD1(1). 2020
                    </li>

                    <li>
                        <a href="https://szczepienia.pzh.gov.pl/"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Narodowy Instytut Zdrowia Publicznego – PZH <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.cdc.gov/vaccines/hcp/imz-schedules/adult-age.html"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            CDC – Adult Immunization Schedule by Age <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://pimr.pl/artykul.php?a=1937"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Sybilski AJ, Mastalerz-Migas A, Jackowska T, et al. Rekomendacje postępowania w grypie u
                            dzieci – KOMPAS GRYPA 23/24. Aktualizacja na sezon 2023/2024. Pediatr Med Rodz 2023; 19 (4):
                            273–283. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.termedia.pl/Towards-better-protection-of-older-people-against-influenza-and-its-complications-Polish-recommendations-for-HD-influenza-vaccine,95,52303,0,1.html"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Nitsch-Osuch A, Jankowski P, Kokoszka-Paszkot J, et al. Towards better protection of older
                            people against influenza and its complications. Polish recommendations for HD influenza
                            vaccine. Fam Med Prim Care Rev. 2024;26(1):116-122. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.termedia.pl/Pneumococcal-vaccination-among-adults-updated-Polish-recommendations,95,47780,1,1.html"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Kuchar E, Antczak A, Skoczyńska A, et al. Pneumococcal vaccination among adults – updated
                            Polish recommendations. Fam Med Prim Care Rev. 2022;24(3):285-291. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://journals.viamedica.pl/polish_heart_journal/article/view/96718"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Mamcarz A, Wełnicki M, Drożdż J, et al. The role of pneumococcal vaccination in reducing the
                            cardiovascular risk of cardiac patients: opinion of experts of the Prevention Committee of
                            the Polish Cardiac Society supported by the Polish Vaccinology Society. Kardiol Pol.
                            2023;Sep 3. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.mp.pl/szczepienia/artykuly/wytyczne/polpasiec-wytyczne/321988,szczepienie-przeciwko-polpascowi-zalecenia-grupy-ekspertow-ptw-ptmr-ptd-ptbb-i-ptn"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Kuchar E, Rudnicka L, Kocot-Kępska M, et al. Szczepienie przeciwko półpaścowi. Zalecenia
                            grupy ekspertów Polskiego Towarzystwa Wakcynologii, Polskiego Towarzystwa Medycyny
                            Rodzinnej, Polskiego Towarzystwa Dermatologicznego, Polskiego Towarzystwa Badania Bólu i
                            Polskiego Towarzystwa Neurologicznego. Med Prakt. 2023;5:64-72. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.termedia.pl/Rekomendacje-Polskiego-Towarzystwa-Ginekologow-i-Poloznikow-Polskiego-Towarzystwa-Pediatrycznego-Polskiego-Towarzystwa-Medycyny-Rodzinnej-Polskiego-Towarzystwa-Ginekologii-Onkologicznej-Polskiego-Towa,98,47500,0,0.html"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Nowakowski A, Jach R, Szenborn L, et al. Rekomendacje Polskiego Towarzystwa Ginekologów i
                            Położników, Polskiego Towarzystwa Pediatrycznego, Polskiego Towarzystwa Medycyny Rodzinnej,
                            Polskiego Towarzystwa Ginekologii Onkologicznej, Polskiego Towarzystwa Wakcynologii oraz
                            Polskiego Towarzystwa Kolposkopii i Patofizjologii Szyjki Macicy w zakresie szczepień
                            profilaktycznych przeciwko zakażeniom wirusami brodawczaka ludzkiego w Polsce. Lekarz POZ.
                            2022;3:195-205. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://medpr.imp.lodz.pl/Epidemiologia-diagnostyka-i-profilaktyka-kleszczowego-zapalenia-mozgu-w-Polsce-i,132383,0,1.html"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Kuchar E, Zajkowska J, Flisiak R, et al. Epidemiologia, diagnostyka i profilaktyka kleszczowego zapalenia mózgu w Polsce i wybranych krajach europejskich – stanowisko polskiej grupy ekspertów. Medycyna Pracy. 2021;72(2) <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        <a href="https://journals.viamedica.pl/ginekologia_polska/article/view/95834"
                           target="_blank"
                           rel="noreferrer"
                           className="bibliography__link"
                        >
                            Seremak-Mrozikiewicz A, Nitsch-Osuch A, Czajkowski K, et al. Guidelines of the Polish Society of Gynecologists and Obstetricians, the Polish Society for Vaccinology, and the Polish Society for Family Medicine on vaccinating women with reproductive plans and pregnant or breastfeeding women. Ginekol Pol. 2023;Aug 21. <ExternalLink size={14}/>
                        </a>
                    </li>

                    <li>
                        ChPL poszczególnych preparatów
                    </li>
                </ol>


            </div>


        </div>
    );
}

export default Bibliography;
